import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import SearchComponent from '../../PricingHub/SearchComponent';

class TecoSummarySearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'datetime',
      required: true,
      defaultValue: moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'datetime',
      required: true,
      defaultValue: moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.serviceType',
      name: 'serviceType',
    },
    {
      label: 'label.usageType',
      name: 'usageType',
    },
    {
      label: 'label.dataType',
      name: 'dataType',
      type: 'select',
      tOptions: 'selections:xaxisParameter',
      required: true,
      defaultValue: 'CALLTYPE',
    },
    {
      label: 'label.dataUnit',
      name: 'dataUnit',
      type: 'select',
      tOptions: 'selections:yaxisParameter',
      required: true,
      defaultValue: 'AMOUNT',
    },
  ];

  btnSpan = 'col-md-6';
}

TecoSummarySearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

TecoSummarySearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(TecoSummarySearchForm);
